import $ from "zeptojs";
import isFunction from "lodash/isFunction";

export function addRefEvents({ eventListeners }) {
  let listeners = eventListeners.get(this);

  if (!listeners) {
    listeners = [];
    eventListeners.set(this, listeners);
  }

  if (this.constructor.analyticsActions) {
    this.constructor.analyticsActions
      .filter(({ ref }) => ref)
      .forEach(({ ref, event, action }) => {
        const $target = $(this.refs[ref]);
        const func = isFunction(action)
          ? action
          : require("../index").AnalyticsActions[action];

        if (!isFunction(func)) {
          throw new Error("could not find analytics function");
        }

        $target.on(event, func);

        listeners.push({ $target, func, event });
      }, this);
  }
}

export function flushRefEvents({ eventListeners }) {
  const listeners = eventListeners.get(this);

  if (!listeners || !listeners.length) {
    return;
  }

  while (listeners.length) {
    const { $target, handler, event } = listeners.pop();
    $target.off(event, handler);
  }
}
